import type { NotificationActionKind, NotificationItem } from "@/types/api";
import { request } from "./transport";

export const notifications = {
  listNotifications: (params?: { archived?: boolean }) => {
    const qs = new URLSearchParams();
    if (params?.archived !== undefined)
      qs.set("archived", String(params.archived));
    const q = qs.toString();
    return request<{ notifications: NotificationItem[] }>(
      `/notifications${q ? `?${q}` : ""}`,
    );
  },

  // NB: server param is `action_kind`, not `action` — Rails reserves :action.
  updateNotification: (id: string, action: NotificationActionKind) =>
    request<{ notification: NotificationItem }>(`/notifications/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ action_kind: action }),
    }),

  deleteNotification: (id: string) =>
    request<{ ok: true }>(`/notifications/${id}`, { method: "DELETE" }),

  markAllNotificationsRead: () =>
    request<{ ok: true }>("/notifications/mark_all_read", { method: "POST" }),
};
